import React from 'react';
import { useEffect } from 'react';
import {
  CookbookTag,
  useTranslator,
  withLoading,
  callNativeMobileApp,
  DietTypesSliderCookbookCategory,
  ListCookbookCategory,
  SliderCookbookCategory,
} from '@front-activerse/common-components';
import { Container, Row, Col } from 'reactstrap';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import MealTypeTag from '../components/MealTypeTag';
import { useOutletContext } from 'react-router-dom';

interface ICookbookTagListContainer {
  categories: (SliderCookbookCategory | ListCookbookCategory | DietTypesSliderCookbookCategory)[];
  mealTypeTags: CookbookTag[];
  tagId: number;
}

const CookbookTagListContainer: React.FC<ICookbookTagListContainer> = ({
  mealTypeTags,
  tagId,
  categories,
}) => {
  const { t } = useTranslator();

  const { trackFirebaseEvent } = useOutletContext<{
    trackFirebaseEvent: (eventName: string, eventPayload: object) => void;
  }>();

  useEffect(() => {
    if (
      window.location.pathname.startsWith('/meals/cookbook/tag/') &&
      window.location.pathname.split('/').length === 5
    ) {
      console.log(
        'title changed tag list: ',
        findTagName(),
        window.location.pathname.split('/').length
      );
      callNativeMobileApp({
        action: 'title_changed',
        payload: {
          // manual pluralization handling
          // - Polish: uses "przepisy" for the plural form.
          // - English: uses "recipes" for the plural form.
          // - Swedish: uses "recept" for the plural form.
          title: findTagName() + ' ' + t('cookbook.mealCategoryThumb.quantityRecipe', { count: 2 }),
        },
      });

      trackFirebaseEvent('screen_view', {
        firebase_screen: 'Cookbook_meal_type',
        selected_diet: tagId,
        meals_tab: 'cookbook',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagId, categories, window.location.pathname]);

  const findTagName = () => {
    const dietTypeCategory = categories.find(
      (category) => category.type === 'DIET_TYPES_SLIDER'
    ) as DietTypesSliderCookbookCategory;

    if (dietTypeCategory && +tagId > 0) {
      return dietTypeCategory.tags.find((tag) => tag.id === +tagId)?.name || '';
    } else {
      return t('cookbook.mealCategoryThumb.allCategories.title');
    }
  };

  return (
    <Layout>
      <TitleBar level={2}>
        {/* manual pluralization handling
        - Polish: uses "przepisy" for the plural form.
        - English: uses "recipes" for the plural form.
        - Swedish: uses "recept" for the plural form. */}
        {findTagName()} {t('cookbook.mealCategoryThumb.quantityRecipe', { count: 2 })}
      </TitleBar>
      <div className="page-template-cookbook">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="cookbook-tag-list-container">
                  {mealTypeTags.map(
                    (tag) =>
                      tag.mealsCount > 0 && (
                        <MealTypeTag
                          key={tag.id}
                          {...tag}
                          dietTypeTagId={tagId}
                          dietTypeName={findTagName()}
                        />
                      )
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder titleBar="" />;

export default withLoading(CookbookTagListContainer, Placeholder);
